import React from 'react';

import { useCurrentTheme } from 'app/shared/theme';
import { Box, Icon, Typography } from 'app/shared/components/atoms';

interface Props {
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  iconFillColor?: string;
  title: string;
}

export const AccordionSectionTitle = ({
  icon,
  title,
  iconFillColor = 'none',
}: Props) => {
  const { colors } = useCurrentTheme();

  return (
    <Box w="100%" h="fit-content" alignItems="center" gap={4}>
      <Icon
        icon={icon}
        size="md"
        fillColor={iconFillColor}
        backgroundColor="transparent"
        strokeColor={colors.accent.primaryAccent.base}
      />
      <Typography
        fontWeight="regular"
        fontSize="fontSize300"
        color={colors.primary.white.base}
      >
        {title}
      </Typography>
    </Box>
  );
};
